import React, { useEffect, useState } from 'react';
import { useLoader } from '../../../../context/LoaderProvider.jsx';

const filterSelectStyle = {
    backgroundColor: "#b15cd6",
    color: "#fff",
    border: "none",
    height: "35px",
    borderRadius: "4px"
};

const filterButtonStyle = {
    backgroundColor: "#b15cd6",
    color: "white",
    border: "none",
    height: "35px",
    borderRadius: "4px",
    padding: "0 15px"
};

const Grocerydataoverview = () => {
    const [activeTab, setActiveTab] = useState('Overview');
    const [data, setData] = useState([]);
    const [searchDate, setSearchDate] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const { showLoader, hideLoader } = useLoader();

    useEffect(() => {
        const controller = new AbortController();
        const fetchOrders = async () => {
            try {
                showLoader();
                const token = localStorage.getItem("authToken");
                const headers = token ? { Authorization: `Bearer ${token}` } : {};

                const res = await fetch(
                    "https://backend.maamaas.com/groceries/api/admin/grocery/orders/all",
                    { headers, signal: controller.signal }
                );

                if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

                const fetchedApiData = await res.json();
                // console.log("✅ API Response:", fetchedApiData);

                // Normalize data
                const normalized = Array.isArray(fetchedApiData)
                    ? fetchedApiData
                    : fetchedApiData.data || [];
                setData(normalized);
            } catch (err) {
                if (err.name !== "AbortError") {
                    console.error("Fetching error:", err);
                    setData([]);
                }
            } finally {
                hideLoader();
            }
        };

        fetchOrders();
        return () => controller.abort();
    }, []);

    // ✅ Filter by date
    useEffect(() => {
        let filtered = [...data];
        if (searchDate) {
            filtered = filtered.filter(item => {
                const date = new Date(item.orderDateTime).toISOString().split('T')[0];
                return date === searchDate;
            });
        }
        setFilteredData(filtered);
    }, [searchDate, data]);

    // ✅ CSV Export
    const handleExport = () => {
        if (!filteredData.length) {
            alert("No data to export for the selected filter.");
            return;
        }

        const escape = (val) => {
            const str = String(val ?? "");
            return str.includes(",") ? `"${str}"` : str;
        };

        const headers = [
            "S.No", "Order ID", "User ID", "Vendor ID", "Location", "Date", "Time",
            "Category", "Item Name", "Qty", "Payment Method", "Status", "Amount"
        ];

        const rows = filteredData.map((item, index) => {
            const firstItem = item.orderItems?.[0] || {};
            return [
                index + 1,
                item.orderId,
                item.userId,
                item.vendorId,
                item.location,
                new Date(item.orderDateTime).toLocaleDateString(),
                new Date(item.orderDateTime).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
                firstItem.groceryCategory || "-",
                firstItem.groceryItemName || "-",
                firstItem.quantity || "-",
                item.paymentMethod,
                item.orderStatus,
                item.total
            ];
        });

        const csv = [headers.map(escape).join(","), ...rows.map(r => r.map(escape).join(","))].join("\n");
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "grocery_orders.csv";
        link.click();
        URL.revokeObjectURL(url);
    };

    return (
        <div className="row" style={{ marginTop: "10px" }}>
            <div className="col-12">
                <div style={{ overflowY: "auto", height: "calc(85vh - 40px)", marginTop: "-60px" }}>
                    <div style={{ marginTop: "20px", borderRadius: "8px" }}>
                        <div className="d-flex flex-wrap align-items-center mb-1 pt-3 rounded ps-0" style={{ gap: "10px" }}>
                            {/* Date Picker */}
                            <div style={{ flex: "0 0 auto" }}>
                                <input
                                    type="date"
                                    value={searchDate}
                                    onChange={(e) => setSearchDate(e.target.value)}
                                    className="form-control form-control-sm"
                                    style={filterSelectStyle}
                                />
                            </div>

                            {/* Export button */}
                            <div className='pe-2' style={{ marginLeft: "auto" }}>
                                <button
                                    type="button"
                                    className="btn btn-sm fw-bold"
                                    style={filterButtonStyle}
                                    onClick={handleExport}
                                >
                                    Export
                                </button>
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table className="table-striped table-bordered align-middle" style={{ fontSize: "0.95rem", width: "100%" }}>
                                <thead>
                                    <tr>
                                        <th style={tableHeaderStyle}>Order ID</th>
                                        <th style={tableHeaderStyle}>User ID</th>
                                        <th style={tableHeaderStyle}>Vendor ID</th>
                                        <th style={tableHeaderStyle}>Location</th>
                                        <th style={tableHeaderStyle}>Date</th>
                                        <th style={tableHeaderStyle}>Time</th>
                                        <th style={tableHeaderStyle}>Category</th>
                                        <th style={tableHeaderStyle}>Item</th>
                                        <th style={tableHeaderStyle}>Qty</th>
                                        <th style={tableHeaderStyle}>Payment</th>
                                        <th style={tableHeaderStyle}>Status</th>
                                        <th style={tableHeaderStyle}>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.length ? (
                                        filteredData.map((item, index) => {
                                            const firstItem = item.orderItems?.[0] || {};
                                            return (
                                                <tr key={item.orderId || index} style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff" }}>
                                                    <td style={tableCellStyle}>{item.orderId}</td>
                                                    <td style={tableCellStyle}>{item.userId}</td>
                                                    <td style={tableCellStyle}>{item.vendorId}</td>
                                                    <td style={tableCellStyle}>{item.location || "-"}</td>
                                                    <td style={tableCellStyle}>{new Date(item.orderDateTime).toLocaleDateString()}</td>
                                                    <td style={tableCellStyle}>{new Date(item.orderDateTime).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</td>
                                                    <td style={tableCellStyle}>{firstItem.groceryCategory || "-"}</td>
                                                    <td style={tableCellStyle}>{firstItem.groceryItemName || "-"}</td>
                                                    <td style={tableCellStyle}>{firstItem.quantity || "-"}</td>
                                                    <td style={tableCellStyle}>{item.paymentMethod}</td>
                                                    <td style={tableCellStyle}>{item.orderStatus}</td>
                                                    <td style={tableCellStyle}>₹{item.total}</td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="12" style={{ ...tableCellStyle, fontStyle: "italic" }}>No data matches your filter.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const tableHeaderStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#b15cd6",
    color: "white",
    padding: 6,
};

const tableCellStyle = {
    border: "1px solid #ddd",
    textAlign: "center",
    padding: 6,
};

export default Grocerydataoverview;
